// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tile[data-v-4d6baa64]{background-color:rgba(10,135,84,.12)}.clickable[data-v-4d6baa64]{cursor:pointer}.v-chip-absolute[data-v-4d6baa64]{position:absolute;top:-5px;left:-5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
